// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"f653e4ef","554":"75fb1b12"}[chunkId] + ".css";
};